import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import ImagemapBannerResponsive from 'yoda-core-components/lib/components/ImagemapBannerResponsive/ImagemapBannerResponsive';
import SiteComponent from 'yoda-site-components/lib/components/SiteComponent/SiteComponent';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import IrisImageBanner from 'yoda-site-components/lib/iris/wrappers/ImageBanner/ImageBanner';

const constructLeaf = (mapArea) => {
    const imageBannerArray =
        mapArea &&
        mapArea.map((data) => {
            const bannerData = {};
            if (data.link && data.link.url) {
                if (data.link.url.indexOf('X2H2') >= 0) {
                    bannerData.leaf = false;
                } else {
                    bannerData.leaf = true;
                }
                bannerData.link = data.link.url;
            }
            bannerData.alt = data.linkText; // for alt Tag
            bannerData.target = data.openInNewTab ? '_blank' : '_self';

            return { ...data, ...bannerData };
        });
    return imageBannerArray || [];
};

const mapIrisToProps = (irisData) => {
    const bannerData = get(irisData, 'content.components[0].content.channels[0]', {});
    if (isEmpty(bannerData)) {
        return null;
    }
    const bannerProps = {
        imageUrl: bannerData.image.url,
        imagemapArea: constructLeaf(bannerData.hotspots),
        imageAltText: bannerData.image.altText,
        analyticsTag: bannerData.analyticsTag,
        automationId: 'image-map-Banner',
    };
    return (
        <div
            className={dt(['justify-center', 'mb-2', 'lg:mb-0', 'mt-4', 'lg:mt-6'])}
            data-automation-id="at-marketing-slot-s1"
        >
            {bannerData.hotspots ? (
                /* eslint-disable-next-line react/jsx-props-no-spreading */
                <ImagemapBannerResponsive {...bannerProps} />
            ) : (
                <IrisImageBanner channels={[bannerData]} />
            )}
        </div>
    );
};

export class MarketingS1Slot extends SiteComponent {
    render() {
        const { zoneData } = this.props;
        if (isEmpty(zoneData)) {
            return null;
        }
        /* istanbul ignore next */
        return mapIrisToProps(zoneData);
    }
}

MarketingS1Slot.defaultProps = {
    zoneData: {},
};

MarketingS1Slot.propTypes = {
    zoneData: PropTypes.oneOfType([PropTypes.object]),
};

const mapStateToProps = (state) => {
    const { marketingSlotBanner } = state;
    return {
        zoneData: marketingSlotBanner,
    };
};

export default connect(mapStateToProps, null)(MarketingS1Slot);
